@if (galleryPermissions().can_edit || theme().cover.design || gallery().title || gallery().description) {
  @if (!uploadingCover()) {
    <app-drop
      (onFileDrop)="dropAsset($event)"
      [borderStyle]="'full'"
      [hoverStyle]="'white'"
      [disable]="!galleryPermissions().can_edit"
      [darkBackground]="darkBackground"
      [class.dont-hide-overflow]="theme().cover.design === 'faded'"
    >
      <div
        class="cover-container size-{{ enableCoverShowMode() ? theme().cover.size : 'tiny' }}"
        [class.editable]="galleryPermissions().can_edit"
        [class.dark-gallery-background]="darkBackground"
        [class.has-asset]="!!gallery().cover.uuid"
        [class.bottom-border]="!enableCoverShowMode()"
        [class.content-left]="theme().cover.design ? theme().cover.content_position?.[0] === 0 : false"
        [class.content-right]="theme().cover.design ? theme().cover.content_position?.[0] === 1 : false"
        [class.content-top]="theme().cover.design ? theme().cover.content_position?.[1] === 0 : false"
        [class.content-bottom]="theme().cover.design ? theme().cover.content_position?.[1] === 1 : false"
        #cover
      >
        <app-cover-design
          [theme]="theme()"
          [gallery]="gallery()"
          [previewAsset]="coverPreviewAsset()"
          [animated]="true"
          [style.color]="theme().cover.title_typography.font_color"
        ></app-cover-design>
        <div class="cover-meta" [class.editable]="galleryPermissions().can_edit">
          @if (gallery().title?.length || galleryPermissions().can_edit) {
            <div
              [@title]
              class="input-container gallery-cover-title-field {{
                getFontSize(theme().cover.title_typography.font_size)
              }}"
              [appApplyTypographyStyles]="[theme().cover?.title_typography, tenant?.default_cover_title_typography]"
            >
              <div
                class="input"
                [attr.contenteditable]="galleryPermissions().can_edit"
                [(wysiwyg)]="title"
                [allowFontChanges]="true"
                [allowHugeFontSize]="true"
                (wysiwygChange)="textChange()"
                [maxLength]="200"
                [fontFamily]="theme().cover.title_typography.font_family"
                [defaultFontFamily]="tenant?.default_cover_title_typography?.font_family"
                [fontSize]="getFontSize(theme().cover.title_typography.font_size) || 'medium'"
                [fontWeight]="theme().cover.title_typography.font_weight"
                [textColor]="theme().cover?.title_typography?.font_color"
                [allowTextColorReset]="false"
                [darkBackground]="darkBackground"
                [showContext]="true"
                (onFontChange)="onTitleFontChange($event)"
                (onFontSizeChange)="onTitleFontSizeChange($event)"
                (onFontWeightChange)="onTitleFontWeightChange($event)"
                (onTextColorChange)="onTitleTextColorChange($event)"
                (onContextClicked)="openThemeMenu('coverTitle')"
              ></div>
              @if (!gallery().title?.length) {
                <div class="placeholder">Add a Title</div>
              }
            </div>
          }
          @if (gallery().description?.length || galleryPermissions().can_edit) {
            <div
              [@description]
              class="input-container gallery-cover-description-field {{
                getFontSize(theme().cover.paragraph_typography.font_size)
              }}"
              [appApplyTypographyStyles]="[theme().cover?.paragraph_typography, tenant?.default_paragraph_typography]"
            >
              <div
                class="input"
                [attr.contenteditable]="galleryPermissions().can_edit"
                [(wysiwyg)]="description"
                [allowHtml]="true"
                [allowFontChanges]="true"
                [showContext]="true"
                [maxLength]="240"
                (wysiwygChange)="textChange()"
                [fontFamily]="theme().cover.paragraph_typography.font_family"
                [defaultFontFamily]="tenant?.default_paragraph_typography?.font_family"
                [fontSize]="getFontSize(theme().cover.paragraph_typography.font_size) || 'medium'"
                [fontWeight]="theme().cover.paragraph_typography.font_weight"
                [textColor]="theme().cover.paragraph_typography.font_color"
                [allowTextColorReset]="false"
                (onFontChange)="onParagraphFontChange($event)"
                (onFontSizeChange)="onParagraphFontSizeChange($event)"
                (onFontWeightChange)="onParagraphFontWeightChange($event)"
                (onTextColorChange)="onParagraphTextColorChange($event)"
                (onContextClicked)="openThemeMenu('coverDescription')"
              ></div>
              @if (!gallery().description?.length) {
                <div class="placeholder">Add a description</div>
              }
            </div>
          }
        </div>
        @if (!enableCoverShowMode() && galleryPermissions().can_edit) {
          <input type="file" id="cover-replace" class="hidden-input" (change)="uploadCoverEvent($event.target)" />
          <div class="fixed-cover-button">
            <app-svg src="/assets/icons/16/section-top.svg" size="-1"></app-svg>
            <span *onlyForScreens="['desktop']"> Drop or </span>
            <label for="cover-replace">Select Cover</label>
          </div>
        }
      </div>
      @if (enableCoverShowMode() && galleryPermissions().can_edit) {
        <ng-container *onlyForScreens="['mobile', 'tablet']">
          <app-context-menu
            [options]="{ width: '240px', noSpacing: true }"
            position="center"
            verticalPosition="top"
            #mobileMenu
          >
            <div class="mobile-edit-button-container" contextButton>
              <button
                class="mobile-edit-cover"
                appButton
                name="mobile-edit"
                location="gallery-cover"
                [hasIcon]="true"
                color="simple-gray-50"
                size="1"
                height="0"
                spacing="1-5"
              >
                <app-svg src="/assets/icons/edit.svg"></app-svg>
                <span>Edit Cover</span>
              </button>
            </div>
            <div contextContent class="button-menu">
              <app-button-menu-item
                name="cover-design"
                location="gallery-cover"
                icon="design"
                (click)="mobileMenu.close(); openEdit('coverItem')"
                [fullWidth]="true"
              >
                Cover Design
              </app-button-menu-item>
              @if (gallery().cover.uuid) {
                <app-button-menu-item
                  name="overlay"
                  location="gallery-cover"
                  imageUrl="/assets/rainbow-circle.png"
                  (click)="mobileMenu.close(); openEdit('overlay')"
                  [fullWidth]="true"
                >
                  Set Overlay
                </app-button-menu-item>
                <app-button-menu-item
                  name="focalpoint"
                  location="gallery-cover"
                  icon="focal"
                  (click)="mobileMenu.close(); openEdit('focal')"
                  [fullWidth]="true"
                >
                  Set Focal Point
                </app-button-menu-item>
              }

              <app-button-menu-item
                name="resize"
                location="gallery-cover"
                icon="height"
                (click)="mobileMenu.close(); openEdit('size')"
                [fullWidth]="true"
              >
                Resize Cover
              </app-button-menu-item>

              <app-button-menu-item
                name="text-position"
                location="gallery-cover"
                icon="alignment-center"
                (click)="mobileMenu.close(); openEdit('textPosition')"
                [fullWidth]="true"
              >
                Text Position
              </app-button-menu-item>
              @if (gallery().cover.uuid) {
                <div class="divider"></div>
                <app-button-menu-item
                  name="delete"
                  location="gallery-cover"
                  icon="trash"
                  color="simple-warn"
                  (click)="mobileMenu.close(); deleteCoverAsset()"
                  [fullWidth]="true"
                >
                  Remove Asset
                </app-button-menu-item>
              } @else {
                <input
                  type="file"
                  id="cover-upload-mobile"
                  class="hidden-input"
                  (change)="uploadCoverEvent($event.target)"
                />
                <label for="cover-upload-mobile" class="mobile-upload-button">
                  <app-button-menu-item name="upload" location="gallery-cover" icon="upload" [fullWidth]="true">
                    Upload Cover
                  </app-button-menu-item>
                </label>
              }
            </div>
          </app-context-menu>
        </ng-container>
        <div
          class="spaced-button-group with-shadow spaced-button-group-round small"
          [class.force-open]="
            sizeMenu.isOpen() ||
            overlayMenu?.isOpen() ||
            focalMenu?.isOpen() ||
            textPositionMenu?.isOpen() ||
            coverItemMenu?.isOpen()
          "
        >
          <div class="spaced-button-group-item">
            <app-context-menu
              [options]="{ width: '320px' }"
              position="screen-center"
              verticalPosition="top"
              #coverItemMenu
            >
              <button
                appButton
                name="cover-select"
                location="gallery-cover"
                [iconButton]="true"
                color="simple"
                height="1"
                shape="round"
                contextButton
                appTooltip="Cover Design"
              >
                <app-svg src="/assets/icons/design.svg" alt="" />
              </button>
              <div contextContent>
                @if (coverItemMenu.isOpen()) {
                  <app-theme-cover-select-item
                    [gallery]="gallery()"
                    (onChanged)="$event || coverItemMenu.close()"
                  ></app-theme-cover-select-item>
                }
              </div>
            </app-context-menu>
          </div>
          <div class="spaced-button-group-item">
            @if (gallery().cover.uuid) {
              <app-context-menu
                [options]="{ width: '272px', noSpacing: true }"
                position="screen-center"
                verticalPosition="top"
                #overlayMenu
              >
                <button
                  appButton
                  name="overlay"
                  location="gallery-cover"
                  [iconButton]="true"
                  color="simple"
                  height="1"
                  shape="round"
                  contextButton
                  appTooltip="Overlay Color"
                >
                  <img src="/assets/rainbow-circle.png" class="px26-image" alt="" />
                </button>
                <div contextContent>
                  @if (overlayMenu?.isOpen()) {
                    <app-color-picker
                      [color]="theme().cover.overlay_color"
                      [allowOpacity]="true"
                      (colorChange)="colorPickerChange($event)"
                    >
                    </app-color-picker>
                  }
                </div>
              </app-context-menu>

              <app-context-menu
                [options]="{ width: theme().cover.size === 'small' ? '240px' : '340px' }"
                position="screen-center"
                (onToggle)="onToggleFocal($event)"
                verticalPosition="top"
                #focalMenu
              >
                <button
                  appButton
                  name="focalpoint"
                  location="gallery-cover"
                  [iconButton]="true"
                  color="simple"
                  height="1"
                  shape="round"
                  contextButton
                  [disabled]="!gallery().cover.uuid"
                  appTooltip="Focal Point"
                >
                  <app-svg src="/assets/icons/focal.svg"></app-svg>
                </button>
                <div contextContent class="focal-point-container">
                  <img
                    [src]="
                      gallery().cover?.uuid
                        | galleryCoverUrl
                          : gallery().cover.width
                          : gallery().cover.height
                          : cover.clientWidth
                          : cover.clientHeight
                          : gallery().cover.ext
                    "
                    alt=""
                  />
                  <div
                    class="focal-point"
                    (touchstart)="touchStart($event, focalPoint)"
                    (touchmove)="touchMove($event, focalPoint)"
                    (mousedown)="mouseDown($event, focalPoint)"
                    (mousemove)="mouseMove($event, focalPoint)"
                    #focalPoint
                  >
                    <div class="focal-point-center" [style.left]="position().x + '%'" [style.top]="position().y + '%'">
                      <app-svg src="/assets/icons/focal.svg"></app-svg>
                    </div>
                  </div>
                </div>
              </app-context-menu>
            }

            <app-context-menu [options]="{ width: '240px' }" position="screen-center" verticalPosition="top" #sizeMenu>
              <button
                appButton
                name="height"
                location="gallery-cover"
                [iconButton]="true"
                color="simple"
                height="1"
                shape="round"
                appTooltip="Cover Size"
                contextButton
              >
                <app-svg src="/assets/icons/height.svg"></app-svg>
              </button>
              <div contextContent>
                <div class="radio-simple">
                  <input
                    type="radio"
                    id="cover-small"
                    name="coverSize"
                    value="small"
                    [ngModel]="theme().cover.size"
                    (ngModelChange)="saveCoverSize($event); sizeMenu.close()"
                  />
                  <label for="cover-small">
                    <div class="radio-simple-icon">
                      <app-svg src="/assets/icons/height-small.svg"></app-svg>
                    </div>
                    <div class="radio-simple-content">Small</div>
                  </label>
                </div>
                <div class="radio-simple">
                  <input
                    type="radio"
                    id="cover-medium"
                    name="coverSize"
                    value="medium"
                    [ngModel]="theme().cover.size"
                    (ngModelChange)="saveCoverSize($event); sizeMenu.close()"
                  />
                  <label for="cover-medium">
                    <div class="radio-simple-icon">
                      <app-svg src="/assets/icons/height-medium.svg"></app-svg>
                    </div>
                    <div class="radio-simple-content">Medium</div>
                  </label>
                </div>
                <div class="radio-simple">
                  <input
                    type="radio"
                    id="cover-large"
                    name="coverSize"
                    value="large"
                    [ngModel]="theme().cover.size"
                    (ngModelChange)="saveCoverSize($event); sizeMenu.close()"
                  />
                  <label for="cover-large">
                    <div class="radio-simple-icon">
                      <app-svg src="/assets/icons/height-large.svg"></app-svg>
                    </div>
                    <div class="radio-simple-content">Large</div>
                  </label>
                </div>
              </div>
            </app-context-menu>

            <app-context-menu
              [options]="{ width: '190px' }"
              position="screen-center"
              (onToggle)="onToggleFocal($event)"
              verticalPosition="top"
              #textPositionMenu
            >
              <button
                appButton
                name="text-position"
                location="gallery-cover"
                [iconButton]="true"
                color="simple"
                height="1"
                shape="round"
                contextButton
                appTooltip="Text Position"
              >
                <app-svg src="/assets/icons/alignment-center.svg"></app-svg>
              </button>
              @if (textPositionMenu?.isOpen()) {
                <div contextContent class="text-position-container">
                  @for (position of textPositions; track position) {
                    <div
                      [class.active]="
                        theme().cover.content_position[0] === position[0] &&
                        theme().cover.content_position[1] === position[1]
                      "
                      (click)="changeTextPosition(position)"
                    >
                      @if (position[0] !== 0.5 || position[1] !== 0.5) {
                        <app-svg src="/assets/icons/arrow-up.svg"></app-svg>
                      }
                      @if (position[0] === 0.5 && position[1] === 0.5) {
                        <app-svg src="/assets/icons/annotate-circle.svg"></app-svg>
                      }
                    </div>
                  }
                </div>
              }
            </app-context-menu>
          </div>
          @if (gallery().cover.uuid) {
            <div class="spaced-button-group-item">
              <button
                appButton
                name="delete"
                location="gallery-cover"
                [iconButton]="true"
                color="simple-warn"
                height="1"
                shape="round"
                appTooltip="Remove Asset"
                (click)="deleteCoverAsset()"
              >
                <app-svg src="/assets/icons/trash.svg"></app-svg>
              </button>
            </div>
          } @else {
            <div class="spaced-button-group-item">
              <input type="file" id="cover-upload" class="hidden-input" (change)="uploadCoverEvent($event.target)" />
              <label
                appButton
                name="upload"
                location="gallery-cover"
                [iconButton]="true"
                color="simple"
                height="1"
                shape="round"
                appTooltip="Upload Cover"
                for="cover-upload"
              >
                <app-svg src="/assets/icons/upload.svg"></app-svg>
              </label>
            </div>
          }
        </div>
      }
    </app-drop>
  } @else {
    <div class="cover-container size-tiny bottom-border">
      <app-loading-indicator></app-loading-indicator>
    </div>
  }
}
